export const GET_HISTORIAL_LIST_SUCCESS = 'GET_HISTORIAL_LIST_SUCCESS';
export const GET_HISTORIAL_LIST_FAIL = 'GET_HISTORIAL_LIST_FAIL';

export const GET_HISTORIAL_SUCCESS = 'GET_HISTORIAL_SUCCESS';
export const GET_HISTORIAL_FAIL = 'GET_HISTORIAL_FAIL';  